module.exports = __webpack_public_path__ + "img/sixpackcarrier47.67503a69.jpg";